import React from "react";
const CS={macro:{bg:"rgba(239,68,68,.12)",color:"#ef4444",label:"거시경제"},
          crypto:{bg:"rgba(59,130,246,.12)",color:"#3b82f6",label:"크립토"},
          default:{bg:"rgba(168,85,247,.12)",color:"#a855f7",label:"이벤트"}};
function daysUntil(d){
  const diff=Math.ceil((new Date(d)-new Date())/(1000*60*60*24));
  if(diff===0)return"오늘";if(diff===1)return"내일";if(diff<0)return`${Math.abs(diff)}일 전`;return`D-${diff}`;
}
export default function EventsPanel({ data }) {
  if (!data?.items?.length) return <p style={{color:"#6b7280"}}>이벤트 없음</p>;
  return (
    <div style={{display:"flex",flexDirection:"column",gap:7}}>
      {data.items.map((ev,i)=>{
        const cat=CS[ev.category]||CS.default; const du=daysUntil(ev.date);
        return (
          <div key={i} style={{display:"flex",gap:10,padding:"9px 12px",background:"#181c24",borderRadius:8,
            border:`1px solid ${["오늘","내일"].includes(du)?cat.color+"55":"#1e2433"}`}}>
            <div style={{minWidth:44,textAlign:"center",padding:"3px 6px",borderRadius:7,
              background:cat.bg,color:cat.color,fontSize:11,fontWeight:700}}>{du}</div>
            <div>
              <p style={{fontWeight:600,fontSize:13,marginBottom:2}}>
                {ev.importance==="high"&&"⚡ "}{ev.title}
              </p>
              <div style={{display:"flex",gap:6}}>
                <span style={{fontSize:11,background:cat.bg,color:cat.color,padding:"1px 7px",borderRadius:5,fontWeight:600}}>{cat.label}</span>
                <span style={{fontSize:11,color:"#6b7280"}}>{ev.date}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
